'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:EmployeeShowCtrl
 * @description
 * # EmployeeShowCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.controllers')
  .controller('EmployeeShowCtrl', ['$scope', '$state', '$stateParams', 'Employee', function($scope, $state, $stateParams, Employee) {
    $scope.employee = {};
    Employee.find($stateParams.employeeId).then(function(response) {
      $scope.employee = response.data.employee;
    }, function(error) {
      Employee.error(error);
    });
  }]);
